import { Navigate } from "react-router-dom";
import { useSetupProgress } from "../../Context/SetupProgressContext";

/**
 * First-time / incomplete payroll → Guided Setup Wizard.
 * Complete orgs → Salary Structures hub.
 */
export default function SalaryV2IndexRedirect() {
  const { progress } = useSetupProgress() || {};

  if (!progress || progress.loading) {
    return (
      <p className="ps-wiz-loading" style={{ padding: "1.5rem" }}>
        Loading payroll setup…
      </p>
    );
  }

  const incomplete = progress.payrollReadiness && !progress.payrollReadiness.complete;
  return <Navigate to={incomplete ? "/salary-v2/setup" : "/salary-v2/structures"} replace />;
}
